import Layout from '../../internal/Layout.vue'
import CalibrationMetricsPage from './calibrationMetrics/calibrationMetrics.vue'

const calibrationMetricsRoutes = {
  component: Layout,
  children: [
    {
      name: 'calibrationMetrics',
      path: '/',
      component: CalibrationMetricsPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default calibrationMetricsRoutes
